<div>
  <div class="form-row">
    <div class="col-12">
      <address-lines [addressFormGroup]="addressFormGroup"></address-lines>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12">
      <!-- city -->
      <app-control-wrapper
        [control]="addressFormGroup.get('city')"
        [errors]="errors.city"
        [helper]="isDesktop ? '' : 'FORM_LABEL.AS_IN_COMMERCIAL_INVOICE'"
      >
        <label for="city" control-label>{{ "LABELS.CITY" | translate }}</label>
        <input
          type="text"
          [formControl]="addressFormGroup.get('city')"
          class="form-control"
          id="city"
          name="city"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F*'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          control-wrapper
          autocomplete="chrome-off"
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row" *ngIf="!buyerSide.includes(code) || isShowCountry">
    <div class="col-12" [ngClass]="{ 'col-md-6': !isShowState && isDesktop }">
      <!-- country -->
      <country-dropdown
        [fc]="formGroup.get(['address', 'country'])"
        [fcValue]="formGroup.get(['address', 'country'])?.value"
        [errors]="errors.country"
        [defaultCountry]="defaultCountry"
        [isShowRequired]="false"
        [isDesktop]="isDesktop"
        [isFilterRestrictedCountries]="isFilterRestrictedCountries"
      ></country-dropdown>
    </div>

    <div class="col-6" *ngIf="isDesktop && !isShowState">
      <!-- postal code -->
      <ng-container *ngTemplateOutlet="postalCode"></ng-container>
    </div>
  </div>
  <div class="form-row" *ngIf="isShowState && !isDesktop">
    <div class="col-12">
      <!-- state -->
      <state-dropdown
        [countryFc]="addressFormGroup.get('country')"
        [stateFc]="addressFormGroup.get('state')"
        [errors]="errors.state"
        [countryCode]="formGroup.get('address').get('country').value?.code || 'US'"
      ></state-dropdown>
    </div>
  </div>
  <div class="form-row" *ngIf="isShowState && isDesktop">
    <div class="col-6">
      <!-- state -->
      <state-dropdown
        [countryFc]="addressFormGroup.get('country')"
        [stateFc]="addressFormGroup.get('state')"
        [errors]="errors.state"
        [countryCode]="formGroup.get('address').get('country').value?.code || 'US'"
      ></state-dropdown>
    </div>
    <div class="col-6">
      <!-- postal code -->
      <ng-container *ngTemplateOutlet="postalCode"></ng-container>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12" *ngIf="!isDesktop">
      <!-- postal code -->
      <ng-container *ngTemplateOutlet="postalCode"></ng-container>
    </div>
  </div>
</div>
<ng-template #postalCode>
  <app-control-wrapper
    [control]="addressFormGroup.get('postalCode')"
    [errors]="errors.postalCode"
    [helper]="isForeignCompany ? null : 'FORM_HELPER.POSTAL_CODE'"
  >
    <label for="postalCode" control-label>
      {{ "FORM_LABEL.POSTALCODE" | translate }}
      <span *ngIf="isSellerSide">{{ "FORM_LABEL.OPTIONAL" | translate }}</span>
    </label>
    <input
      type="text"
      [pattern]="postalCodePattern"
      inputmode="{{ isForeignCompany ? 'text' : 'numeric' }}"
      [formControl]="addressFormGroup.get('postalCode')"
      class="form-control"
      id="postalCode"
      name="postalCode"
      [mask]="postalCodeMask"
      [appMaskErrorTooltip]="postalCodeMaskTooltip"
      [maxMaskLength]="9"
      [dropSpecialCharacters]="false"
      [patterns]="CUSTOM_MASK"
      control-wrapper
      autocomplete="chrome-off"
    />
  </app-control-wrapper>
</ng-template>
